// Escapa caracteres especiais de HTML em texto de usuário antes de injetá-lo
// em strings HTML montadas por concatenação (popups do Leaflet, relatórios
// impressos via document.write/window.open) — pontos que NÃO passam pelo
// escape automático do React (que só se aplica a JSX renderizado por ele).
// Sem isso, um campo de texto livre (nome de área, observação de RIT etc.)
// com algo como `<img src=x onerror=...>` executa no navegador de quem
// visualizar aquele popup/relatório.
export function escapeHtml(str) {
  return String(str ?? "").replace(/[&<>"']/g, c => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  }[c]));
}

// Para texto de usuário que vira parâmetro dentro de uma string JS de aspas
// simples embutida num atributo onclick="..." (ex.: popups do Leaflet, que
// não são JSX — o React não escapa nada aqui). Escapa primeiro para o
// contexto de string JS (\ e ') e depois para o contexto de atributo HTML
// (&, <, >, ") — a ordem importa: o navegador desfaz o escape HTML do
// atributo ANTES de entregar o valor como código JS ao onclick.
export function escapeJsAttr(str) {
  const jsSafe = String(str ?? "").replace(/\\/g, "\\\\").replace(/'/g, "\\'");
  return escapeHtml(jsSafe);
}

// Percorre recursivamente um documento (RIT, homenagem etc.) e escapa toda
// string encontrada, preservando números/booleans/null/Timestamps do
// Firestore intactos. Usado nos geradores de PDF/relatório (document.write)
// para não precisar escapar campo por campo em templates com dezenas de
// interpolações — aplica-se uma vez no objeto inteiro, no topo da função,
// antes de montar o HTML.
// Não usar em objetos cujos campos de texto sejam depois lidos em contexto
// JS puro (ex.: dentro de um <script> via JSON.stringify) — nesse caso o
// escape de HTML apareceria literalmente no texto (ex.: "&#39;" em vez de
// apóstrofo). Nenhum dos geradores de PDF atuais faz isso.
export function escapeDeepStrings(value) {
  if (typeof value === "string") return escapeHtml(value);
  if (Array.isArray(value)) return value.map(escapeDeepStrings);
  if (value && typeof value === "object") {
    if (typeof value.toDate === "function" || value instanceof Date) return value;
    const out = {};
    for (const k of Object.keys(value)) out[k] = escapeDeepStrings(value[k]);
    return out;
  }
  return value;
}
